import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets the window scroll position whenever the route pathname changes, so
// that a page reached from a scrolled view (e.g. the dashboard) starts at the
// top. Changes to the search params only (same view, different filters) keep
// the current scroll position.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
  }, [pathname]);

  return null;
}
